import './style.scss'

function DBCheckbox(props) {
  const {checked, onClick} = props
  return (
    <div className='DB-checkbox' onClick={onClick}>
      <div className={checked ? "selected" : ""}>
        <div></div>
      </div>
    </div>
  );
}

export default DBCheckbox;
